// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box-activities {\n  height: 260px;\n  overflow-y: scroll;\n}\n[dir] .m-top-20 {\n  margin-top: 20px;\n}\n.title-activity {\n  color: #671e85;\n}\n.chip-custom {\n  font-size: 12px;\n  color: #ffb300;\n}\n[dir] .chip-custom {\n  margin-top: 10px;\n  background: #fff5df;\n  border-radius: 10px;\n  padding: 4px 8px;\n}\n", ""]);
// Exports
module.exports = exports;
